'use client';
import styled from '@benzinga/themetron';
import React from 'react';
import {
  FusionSection,
  FusionSectionCaption,
  FusionSectionContent,
  FusionSectionText,
  FusionSectionTitle,
} from '@benzinga/ui';

const OurFocus = () => {
  return (
    <StyledSection>
      <StyledSectionContent paddingHorizontal={false}>
        <ContentWrapper>
          <StyledSectionCaption>OUR FOCUS</StyledSectionCaption>
          <StyledSectionTitle>
            Benzinga is a leading media and data technology platform dedicated to empowering the next generation of
            investors.
          </StyledSectionTitle>
          <StyledSectionText>
            Since its launch in 2010, Benzinga.com has grown into a trusted source for actionable information on the
            capital markets, attracting approximately 25 million readers each month. Through a commitment to innovation
            and financial accessibility, Benzinga continues to evolve as a premier destination for financial news, data,
            and market insights.
          </StyledSectionText>
        </ContentWrapper>
      </StyledSectionContent>
    </StyledSection>
  );
};

export default OurFocus;

const StyledSection = styled(FusionSection)`
  background-image: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
`;

const StyledSectionContent = styled(FusionSectionContent)`
  position: relative;
  padding-bottom: 48px !important;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ContentWrapper = styled.div`
  flex-grow: 1;
`;

const StyledSectionCaption = styled(FusionSectionCaption)`
  margin-bottom: 12px;
`;

const StyledSectionTitle = styled(FusionSectionTitle)`
  margin-bottom: 16px;
`;

const StyledSectionText = styled(FusionSectionText)`
  margin-bottom: 24px;
`;
